var map = {
	"./ad-1.jpg": 672,
	"./ad-2.jpg": 673,
	"./ad-3.jpg": 674,
	"./ad-4.jpg": 675,
	"./ad-5.jpg": 676,
	"./ad-6.jpg": 677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 671;